import { toast } from "react-toastify";

export default function useFormSubmit({ formRef, t }) {
  const validate = () => {
    const instance = formRef.current;

    const isValid = instance.checkValidity(
      instance.submission.data,
      true,
      instance.submission.data
    );

    if (!isValid) {
      instance.showErrors();
      toast.error(t("Please correct the errors before submitting."));
      return false;
    }

    return true;
  };

  return { validate };
}